import {ApiRepository} from '../base/api-repository';
import {action, makeObservable, observable} from 'mobx';
import {UserStore} from '../user/user-store';
import {LabelStore} from '../base/label-store';
import {ViewStore} from '../base/view-store';
import {Category} from '../questions/questions-store';


export class CategoriesStore extends ViewStore {

    @observable
    categories?: Category[] = undefined;

    constructor(
        private api: ApiRepository,
        labelStore: LabelStore,
        private userStore: UserStore,
    ) {
        super(labelStore);
        makeObservable(this);
    }

    @action
    onEnter(): void {
        this.load(async () => {
            await this.refreshPayload();
        });
    }

    @action
    async refreshPayload(): Promise <void> {
        this.categories = await this.api.get<Category[]>(`/categories/employee/${this.userStore.payload!.employeeId}`);
    }
}
